const DEFAULT_PAGE_TITLE = 'Tracking Football';

export function updatePageTitle(pageTitle:string) {
  document.title = !!pageTitle ? `${pageTitle} | ${DEFAULT_PAGE_TITLE}` : DEFAULT_PAGE_TITLE;
}